import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full">
      <nav className="bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="text-2xl font-heading font-bold text-primary-500">🍌</span>
              <span className="text-xl font-heading font-bold text-foreground-950">香蕉影视</span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                    location.pathname.includes(`/category/${cat.slug}`)
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <Link
                to="/about"
                className="text-sm text-foreground-600 hover:text-foreground-950 whitespace-nowrap cursor-pointer transition-colors"
              >
                关于我们
              </Link>
            </div>

            <button className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer" aria-label="菜单">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}